import useAsyncDataState from './useAsyncDataState'

export default (asyncFunction) => {
  const {
    setState: { onAttempt, onFailure, onSuccess },
    state,
  } = useAsyncDataState()

  const makeRequest = async (...arguments_) => {
    onAttempt()
    try {
      const response = await asyncFunction(...arguments_)
      onSuccess(response)
      return response
    } catch (error) {
      onFailure(error)
      throw error
    }
  }

  return {
    ...state,
    makeRequest,
  }
}
